import React from 'react';
import OlMap from 'ol/Map';
const MapContext = React.createContext<OlMap|undefined>(undefined);
export default MapContext;
